import { FunctionComponent } from "react";
import "./home.scss";
import BuyNowButton from "../shared/buy-now-button/buy-now-button";
import OurFormula from "../freetrial/our-formula";
import ImageBanner from "./imagebanner";
import H1 from "../shared/html-tags/h1";
import { Box } from "@mui/material";

export type Props = {};

const HomeTopBanner: FunctionComponent<Props> = (props) => {
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------

  return (
    <div
      className="page-content bg-top-home bg-top1 "
      style={{
        height: "25.25rem",
        paddingTop: "0.25rem",
        paddingBottom: "0.25rem",
      }}
    >
      <div className="inner-content">
        <div style={{ position: "relative" }}>
          <div
            style={{
              color: "black",
              position: "absolute",
              width: "32rem",
              height: "18rem",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "start",
              marginLeft: "0rem",
              marginTop: "2rem",
              backgroundColor: "transparent",
            }}
            className="top-banner-left-content"
          >
            <h2 style={{ marginBottom: "0", marginLeft: "-0rem" }}>
              <OurFormula borderColor="transparent" lineColor="black" />
            </h2>
            <H1
              language="de"
              style={{ fontSize: "1.2rem", marginLeft: "1.25rem" }}
            >
              Unsere Formel für mehr Funktionen und weniger Kosten
            </H1>
            <BuyNowButton order={"buy"} />

            <ImageBanner />
          </div>
        </div>
      </div>
      <Box className="inner-content">
        <img
          src="/img/home/top-banner/83-976x500.png"
          alt=""
          style={{ border: "none", maxHeight: "19.5rem" }}
          className="top-banner-frame-img"
        />
        <Box
          component="img"
          src="/img/home/top-banner/74-648x500.png"
          alt=""
          sx={{ border: "none", maxHeight: "20rem" }}
          className="top-banner-pc-img"
        />
      </Box>
    </div>
  );
};

export default HomeTopBanner;
